var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.role === 'webmaster')?_vm._t("webmaster"):(_vm.role === 'advertiser')?_vm._t("advertiser"):(_vm.role === 'admin')?_vm._t("admin"):_c('div',{staticClass:"loader-wrapper"},[_c('b-loading',{attrs:{"active":true,"is-full-page":false}})],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }